import { memo, useMemo, useRef } from "react";
import { Divider } from "@mui/material";
import { useGetColumns } from "../hooks/useGetColumns";
import { PreLiquidacionGrillaPorProfesional } from "./PreLiquidacionGrillaPorProfesional";
import { ESTADOS_LIQUIDACION } from "../utils/constants";

const PreLiquidacionGrillaWrapperBase = ({
    idProfesional,
    profesionalData,
    liquidaciones,
    mesLiquidado,
    allowedWrite,
    seleccionadosProfesional,
    toggleSeleccion,
    seleccionarTodos,
    handleEditAjuste,
    handleViewDetalle,
    handleDeleteAjuste,
    showDivider,
    idEstadoLiquidacionProfesional
}) => {
    // Estabilizamos los handlers con refs para que useGetColumns no regenere columns
    // cuando el padre pasa nuevas instancias de funciones en cada render
    const handleEditAjusteRef = useRef(handleEditAjuste);
    handleEditAjusteRef.current = handleEditAjuste;
    const handleViewDetalleRef = useRef(handleViewDetalle);
    handleViewDetalleRef.current = handleViewDetalle;
    const handleDeleteAjusteRef = useRef(handleDeleteAjuste);
    handleDeleteAjusteRef.current = handleDeleteAjuste;

    const stableHandleEdit = useRef((...args) => handleEditAjusteRef.current(...args)).current;
    const stableHandleView = useRef((...args) => handleViewDetalleRef.current(...args)).current;
    const stableHandleDelete = useRef((...args) => handleDeleteAjusteRef.current(...args)).current;

    const liquidacionesElegibles = useMemo(
        () => (liquidaciones || []).filter(l => l.tieneConexion || l.figuraProfesional.toUpperCase() === 'EVALUADOR'),
        [liquidaciones]
    );

    const columns = useGetColumns({
        allowedWrite,
        handleClickEdit: stableHandleEdit,
        handleView: stableHandleView,
        handleDeleteAjuste: stableHandleDelete,
        idProfesional,
        seleccionadosProfesional,
        toggleSeleccion,
        seleccionarTodos,
        liquidacionesElegibles,
        liqProfAprobadoFinal: idEstadoLiquidacionProfesional === ESTADOS_LIQUIDACION.SAP
    });

    return (
        <>
            <PreLiquidacionGrillaPorProfesional
                idProfesional={idProfesional}
                columns={columns}
                profesionalData={profesionalData}
                liquidaciones={liquidaciones}
                mesLiquidado={mesLiquidado}
                allowedWrite={allowedWrite}
                seleccionadosProfesional={seleccionadosProfesional}
                seleccionarTodos={seleccionarTodos}
            />
            {showDivider && <Divider sx={{ my: 2.5 }} />}
        </>
    );
};

export const PreLiquidacionGrillaWrapper = memo(
    PreLiquidacionGrillaWrapperBase,
    (prev, next) => {
        // Re-renderizar SOLO si cambió algo de este profesional específico
        // (no cuando cambia la selección de otro profesional)
        return (
            prev.idProfesional === next.idProfesional &&
            prev.liquidaciones === next.liquidaciones &&
            prev.profesionalData === next.profesionalData &&
            prev.seleccionadosProfesional === next.seleccionadosProfesional &&
            prev.mesLiquidado === next.mesLiquidado &&
            prev.allowedWrite === next.allowedWrite &&
            prev.showDivider === next.showDivider &&
            prev.idEstadoLiquidacionProfesional === next.idEstadoLiquidacionProfesional
            // Los handlers no se comparan — son estables por ref internamente
        );
    }
);
